import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { VenderResponseEntity } from '../../domain/entities/VenderResponseEntity'
import { VenderMiniModel } from './VenderMiniModel'
import type { Pagination1OfVenderMiniDto } from '@/backend/market'

export class VenderResponseModel extends VenderResponseEntity {
  constructor(dataDto: Pagination1OfVenderMiniDto) {
    super()
    const venderMiniModel = dataDto.items?.map((item) => new VenderMiniModel(item))
    mapEntityProperties<VenderResponseEntity>(this, dataDto, {
      map: {
        items: venderMiniModel
      }
    })
  }
}
